import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EMPTY_STRING } from "src/app/common/Const";
import { ME100010, ME200004, ME200005 } from "src/app/common/const-message-id";
import { GC_D0046_VALID, GC_D2016_NORMAL_SLIP, GC_D2087_REQUESTING } from "src/app/common/ConstCcd";
import { NumberKeypadComponent } from "src/app/partsCommon/number-keypad/number-keypad.component";
import { ReqAccess } from "src/app/request/req-access";
import { ReqTst010GetCurrentStock } from "src/app/request/req-tst010-get-current-stock";
import { Spmt10311HeaderDto, Spmt10311SearchRowDto } from "src/app/response/rsp-spmt10311-search";
import { KbnSearchDto } from "src/app/response/rsp-tmt050-all-kbn-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";

class Constant {
  public static readonly DT_QTY_FORM = "dtQtyForm";
  public static readonly SLIP_DTL_COMMENT_FORM = "slipDtlCommentForm";
  public static readonly DISPOSAL_REASON_FORM = "disposalReasonForm";

  public static readonly DT_QTY_LABEL = "数量";
  public static readonly DT_QTY_MIN = 1;
}
@Component({
  selector: "app-spmt10311-detail-dialog",
  templateUrl: "./spmt10311-detail-dialog.component.html",
  styleUrls: ["./spmt10311-detail-dialog.component.css"],
})
export class Spmt10311DetailDialogComponent implements OnInit {
  formGroup: FormGroup;
  slipKbnList: KbnSearchDto[] = [];
  requiredMessage: string;
  rangeMessage: string;
  outStockMessage: string;
  currentStockQty: number;
  @ViewChild("keypad", { static: true }) numberKeypadComponent: NumberKeypadComponent;

  get Constant() {
    return Constant;
  }

  constructor(
    private readonly dialogRef: MatDialogRef<Spmt10311DetailDialogComponent>,
    private readonly commonService: CommonService,
    private readonly message: MessageService,
    private readonly httpBasic: HttpBasicService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      maxQuantity: number;
      access: ReqAccess;
      detailData: Spmt10311HeaderDto;
      slipKbnList: KbnSearchDto[];
      existsReasons: string[];
      product: Spmt10311SearchRowDto;
      btnTitle: string;
    },
    private readonly fb: FormBuilder
  ) {
    this.requiredMessage = message.message[ME100010];
    this.rangeMessage = message.message[ME200005]?.replace("%1", Constant.DT_QTY_LABEL).replace("%2", Constant.DT_QTY_MIN.toString()).replace("%3", this.data.maxQuantity.toString());
  }

  ngOnInit() {
    this.slipKbnList = this.data.slipKbnList.filter((item) => !this.data.existsReasons.includes(item.kbn));
    this.formGroup = this.fb.group({
      dtQtyForm: [{ value: this.data.product.dtQty ?? EMPTY_STRING, disabled: !this.isValidReqStatus() }, [Validators.required, Validators.min(1), Validators.max(this.data.maxQuantity)]],
      slipDtlCommentForm: [{ value: this.data.product.slipDtlComment ?? EMPTY_STRING, disabled: !this.isValidReqStatus() }, [Validators.maxLength(256)]],
      disposalReasonForm: [{ value: this.data.product.disposalReason ?? this.slipKbnList[0].kbn, disabled: !this.isValidReqStatus() }, [Validators.required]],
    });
    if (this.commonService.config.use10KeyPad && this.isValidReqStatus()) {
      this.numberKeypadComponent.setTargetForm(this.formGroup.get(Constant.DT_QTY_FORM) as FormControl);
    }
    this.numberKeypadComponent.setMaxCol(6);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      document.getElementById("dtQty")?.focus();
    }, 300);
  }

  isKeyboardLocked() {
    if (this.numberKeypadComponent.isKeyboardLocked()) return true;
    return false;
  }

  is10KeyPadTarget(ctrlNm: string) {
    const control = this.formGroup.get(ctrlNm) as FormControl;
    if (control === this.numberKeypadComponent.inputField) return true;
    return false;
  }

  isValidReqStatus(): boolean {
    return (
      (!this.data.detailData.reqStatus || this.data.detailData.reqStatus === GC_D2087_REQUESTING) &&
      (!this.data.detailData.redBlackFlg || this.data.detailData.redBlackFlg === GC_D2016_NORMAL_SLIP) &&
      (!this.data.detailData.slipCancelFlg || this.data.detailData.slipCancelFlg === GC_D0046_VALID)
    );
  }

  onAdd() {
    if (this.formGroup.invalid) return;
    this.checkStockQty();
  }

  checkStockQty() {
    const errors = this.formGroup.get(Constant.DT_QTY_FORM).errors;
    if (errors?.required || errors?.min || errors?.max) return;
    const req: ReqTst010GetCurrentStock = {
      access: this.data.access,
      storeCd: this.data.detailData.storeCd,
      productCd: this.data.product.productCd,
    };
    this.httpBasic.beforeRequestStart();
    this.httpBasic.tst010GetCurrentStock(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        const currentQty = res.data?.currentStockQty ?? 0;
        if (this.formGroup.get(Constant.DT_QTY_FORM).value > currentQty) {
          this.outStockMessage = this.message.message[ME200004]?.replace("%1", Constant.DT_QTY_LABEL).replace("%2", currentQty.toString());
          this.formGroup.get(Constant.DT_QTY_FORM).setErrors({ stockQtyError: true });
          return;
        }
        this.dialogRef.close({
          ...this.data.product,
          dtQty: this.formGroup.get(Constant.DT_QTY_FORM).value,
          disposalReason: this.formGroup.get(Constant.DISPOSAL_REASON_FORM).value,
          slipDtlComment: this.formGroup.get(Constant.SLIP_DTL_COMMENT_FORM).value,
        });
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }
}
